module.exports = __webpack_public_path__ + "static/media/netlify.22f93e35.png";